import $ from "jquery";

class Contacts {

    constructor() {
        this.init();
    }

    init() {
        this.$container = $('.js-contacts');
        if (this.$container.length === 0) {
            return;
        }
        this.$map = this.$container.find('.js-map');
        this.centerCoords = this.$map.data('center').split(',');
        this.officeCoords = this.$map.data('office').split(',');
        this.path = this.$map.data('path');
        this.$buildRoute = this.$container.find('.js-build-route');
        this.$addressInput = this.$container.find('.js-address-input');
        this.$routesList = this.$container.find('.js-routes-list');
        this.$routesPresets = this.$container.find('.js-routes-presets');
        if (this.$map.length) {
            this.loadMap();
        }
        this.map = null;
        this.currentRoute = null;

    }

    loadMap() {
        $('<script src="//api-maps.yandex.ru/2.1/?lang=ru_RU" type="text/javascript"></script>').appendTo('body');
        const mapLoader = setInterval(() => {
            if (typeof(ymaps) === 'object' && typeof(ymaps.Map) === 'function') {
                ymaps.ready(() => {
                    this.initMap();
                });
                clearInterval(mapLoader);
            }
        }, 100);
    }

    initMap() {
        this.map = new ymaps.Map(this.$map.get(0), {
            center: this.centerCoords,
            zoom: 16,
            controls: []
        }, {
            searchControlProvider: 'yandex#search'
        });

        this.map.behaviors.disable('scrollZoom');

        this.initMapControls();
        this.drawSalesOffice();
        this.initRoutesList();
    }

    initMapControls() {
        const $map = this.$map;
        const map = this.map;

        const ZoomLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="map-box__zoomBox">' +
            '<button type="button" class="map__icon js-map-zoom-in">' +
            '<svg><use xlink:href="#spr-plus" /></svg>' +
            '</button>' +
            '<button type="button" class="map__icon js-map-zoom-out">' +
            '<svg><use xlink:href="#spr-minus" /></svg>' +
            '</button>' +
            '</div>', {
                    build: function () {
                        ZoomLayout.superclass.build.call(this);
                        this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                        this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);
                        $map.find('.js-map-zoom-in').bind('click touchend', this.zoomInCallback);
                        $map.find('.js-map-zoom-out').bind('click touchend', this.zoomOutCallback);
                    },
                    clear: function () {
                        $map.find('.js-map-zoom-in').unbind('click touchend', this.zoomInCallback);
                        $map.find('.js-map-zoom-out').unbind('click touchend', this.zoomOutCallback);
                        ZoomLayout.superclass.clear.call(this);
                    },
                    zoomIn: function () {
                        const map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                    },
                    zoomOut: function () {
                        const map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                    }
                }),
            zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});
        map.controls.add(zoomControl);


        $('.js-route-preset').each((i, el) => {
            const address = $(el).data('reference');
            const routingMode = $(el).data('routing-mode');
            $(el).on('click', () => {

                this.clearRoute();

                const multiRouteModel = new ymaps.multiRouter.MultiRouteModel([
                    address,
                    this.officeCoords
                ], {
                    boundsAutoApply: true,
                    routingMode
                });

                let icon;
                if (routingMode == 'pedestrian') {
                    icon = 'pedestrian';
                } else {
                    icon = 'car';
                }

                const layout = ymaps.templateLayoutFactory.createClass(`
                <div class="map__placemark">
                    <svg class="map__placemark__body"><use xlink:href="#spr-marker" /></svg>
                    <svg class="map__placemark__shadow"><use xlink:href="#spr-marker-shadow" /></svg>
                    <svg class="map__placemark__icon"><use xlink:href="#spr-${icon}" /></svg>
                </div>`);

                this.currentRoute = new ymaps.multiRouter.MultiRoute(multiRouteModel, {
                    wayPointStartIconLayout: layout,
                    wayPointStartIconShape: {
                        type: 'Rectangle',
                        // Прямоугольник описывается в виде двух точек - верхней левой и нижней правой.
                        coordinates: [
                            [0, 0], [1, 1]
                        ]
                    },
                    wayPointFinishIconLayout: "default#imageWithContent",
                    wayPointFinishIconImageHref: this.path + 'map-marker-office.png',
                    wayPointFinishIconImageSize: [48, 64],
                    wayPointFinishIconImageOffset: [-24, -64],

                    // wayPointDraggable: true,
                    // viaPointDraggable: true,
                    boundsAutoApply: true,
                    routeActiveStrokeColor: "cd9932",
                    routeMarkerIconLayout: false,
                    // routeWalkMarkerIcon: false,
                    // pinIcon: false
                });

                map.geoObjects.add(this.currentRoute);

                $('.map__aside__routes__item_active').removeClass('map__aside__routes__item_active');
                $(el).addClass('map__aside__routes__item_active');

                $('html, body').animate({
                    scrollTop: 0
                }, 200);

            });
        });
    }

    drawSalesOffice() {
        const officeSales = new ymaps.Placemark(this.officeCoords, {},
            {
                iconLayout: 'default#imageWithContent',
                iconImageHref: this.path + 'map-marker-office.png',
                iconImageSize: [48, 64],
                iconImageOffset: [-24, -64]
            }
        );

        this.map.geoObjects.add(officeSales);

        this.map.events.add('click', (e) => {
            const clickPoint = e.get('coords');

            const customAddress = ymaps.geocode(clickPoint);

            customAddress.then(
                (res) => {
                    const objectName = res.geoObjects.get(0).properties.get('name');
                    this.$addressInput.filter(':visible').val(objectName);
                },
                (err) => {
                    console.log(err);
                    console.log('Адрес не найден');
                }
            );

            this.setRoute(clickPoint);
        });

        new ymaps.SuggestView(this.$addressInput.filter(':visible').get(0));

        this.$buildRoute.on('click', (e) => {
            e.preventDefault();
            const addressInput = this.$addressInput.filter(':visible').val();
            const customAddress = ymaps.geocode(addressInput);
            customAddress.then(
                (res) => {
                    const coords = res.geoObjects.get(0).geometry.getCoordinates();
                    this.setRoute(coords);
                },
                (err) => {
                    console.log(err);
                    console.log('Адрес не найден');
                }
            );
        });

    }

    clearRoute() {
        this.map.geoObjects.remove(this.currentRoute);
        this.currentRoute = null;
    };

    setRoute(clickPoint) {
        this.clearRoute();

        const multiRouteModel = new ymaps.multiRouter.MultiRouteModel([
                clickPoint,
                this.officeCoords
            ], {
                // Путевые точки можно перетаскивать.
                // Маршрут при этом будет перестраиваться.
                wayPointDraggable: true,
                boundsAutoApply: true
            });

        const layout = ymaps.templateLayoutFactory.createClass(`
                <div class="map__placemark">
                    <svg class="map__placemark__body"><use xlink:href="#spr-marker" /></svg>
                    <svg class="map__placemark__shadow"><use xlink:href="#spr-marker-shadow" /></svg>
                    <svg class="map__placemark__icon"><use xlink:href="#spr-car" /></svg>
                </div>`);

        this.currentRoute = new ymaps.multiRouter.MultiRoute(multiRouteModel, {
            wayPointStartIconLayout: layout,

            wayPointFinishIconLayout: "default#imageWithContent",
            wayPointFinishIconImageHref: this.path + 'map-marker-office.png',
            wayPointFinishIconImageSize: [48, 64],
            wayPointFinishIconImageOffset: [-24, -64],

            wayPointDraggable: true,
            viaPointDraggable: true,
            boundsAutoApply: true,
            routeActiveStrokeColor: "cd9932",
        });

        const currentRoute = this.currentRoute;

        ymaps.modules.require([
            'MultiRouteCustomView'
        ], (MultiRouteCustomView) => {
            // Создаем экземпляр текстового отображения модели мультимаршрута.
            new MultiRouteCustomView(multiRouteModel);
        });

        this.currentRoute.events.once('update', function () {
            // handle click on routes list
            $(document).on('click', '.js-route', function() {
                const index = $(this).data('index');
                const routes = currentRoute.getRoutes();
                const route = routes.get(index);
                $('.map__aside__routes__item_active').removeClass('map__aside__routes__item_active');
                $(this).addClass('map__aside__routes__item_active');
                currentRoute.setActiveRoute(route);
            });
        });

        this.map.geoObjects.add(this.currentRoute);

    };

    initRoutesList() {
        const $routesList = this.$routesList;
        const $routesPresets = this.$routesPresets;

        ymaps.modules.define('MultiRouteCustomView', [
            'util.defineClass'
        ], function (provide, defineClass) {
            // Класс простого текстового отображения модели мультимаршрута.
            function CustomView (multiRouteModel) {
                this.multiRouteModel = multiRouteModel;
                // Объявляем начальное состояние.
                this.state = "init";
                this.stateChangeEvent = null;
                // Элемент, в который будет выводиться текст.

                this.rebuildOutput();

                // Подписываемся на события модели, чтобы
                // обновлять текстовое описание мультимаршрута.
                multiRouteModel.events
                    .add(["requestsuccess", "requestfail", "requestsend"], this.onModelStateChange, this);
            }

            // Таблица соответствия идентификатора состояния имени его обработчика.
            CustomView.stateProcessors = {
                init: "processInit",
                requestsend: "processRequestSend",
                requestsuccess: "processSuccessRequest",
                requestfail: "processFailRequest"
            };

            // Таблица соответствия типа маршрута имени его обработчика.
            CustomView.routeProcessors = {
                "driving": "createCommonRouteOutput",
                "masstransit": "createCommonRouteOutput",
                "pedestrian": "createCommonRouteOutput"
            };

            defineClass(CustomView, {
                // Обработчик событий модели.
                onModelStateChange: function (e) {
                    // Запоминаем состояние модели и перестраиваем текстовое описание.
                    this.state = e.get("type");
                    this.stateChangeEvent = e;
                    this.rebuildOutput();
                },

                rebuildOutput: function () {
                    // Берем из таблицы обработчик для текущего состояния и исполняем его.
                    var processorName = CustomView.stateProcessors[this.state];
                    $routesList.show().html(
                        this[processorName](this.multiRouteModel, this.stateChangeEvent)
                    );
                    $routesPresets.hide();
                },

                processInit: function () {
                    return "Инициализация ...";
                },

                processRequestSend: function () {
                    return "Запрос данных ...";
                },

                processSuccessRequest: function (multiRouteModel, e) {
                    var routes = multiRouteModel.getRoutes(),
                        result = [];
                        console.log('Данные успешно получены.');
                    if (routes.length) {
                        // result.push("Всего маршрутов: " + routes.length + ".");
                        for (var i = 0, l = routes.length; i < l; i++) {
                            result.push(this.processRoute(i, routes[i]));
                        }
                    } else {
                        result.push("Нет маршрутов.");
                    }
                    return result.join("<br/>");
                },

                processFailRequest: function (multiRouteModel, e) {
                    return e.get("error").message;
                },

                processRoute: function (index, route) {
                    // Берем из таблицы обработчик для данного типа маршрута и применяем его.
                    var processorName = CustomView.routeProcessors[route.properties.get("type")];
                    return this[processorName](index, route);
                },

                // Метод, формирующий общую часть описания для всех типов маршрутов.
                createCommonRouteOutput: function (index, route) {
                    const html = "<div class='map__aside__routes__item js-route " + (index===0 ? 'map__aside__routes__item_active' : '') + "' data-index='" + index + "'>" +
                        "<div class='map__aside__routes__item__icon'><svg><use xlink:href='#spr-car' /></svg></div>" +
                        "<div class='map__aside__routes__item__text'>" + route.properties.get("duration").text + " на авто</div>" +
                        "</div>";

                    return html;
                    // return "Протяженность маршрута: " + route.properties.get("distance").text + "<br/>";
                },

                destroy: function () {
                    $routesList.hide().html('');
                    this.multiRouteModel.events
                        .remove(["requestsuccess", "requestfail", "requestsend"], this.onModelStateChange, this);
                    $routesPresets.show();
                }
            });

            provide(CustomView);
        });
    }
}

export default new Contacts();



// WEBPACK FOOTER //
// ./js/contacts.js